module.exports = __webpack_public_path__ + "876af41647361fd493fedfc08484771e.mp4";